import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.8/js/sparta-validation-framework";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.7/js/sparta-messaging-utility";
import spartaTemplates from "modules/login/ah-caw-cq-module/5.2.1/js/templates";
import "css!modules/login/ah-caw-cq-module/5.2.1/css/ah-caw-cq-module.scss.css";



export default class ahCawCqView {
  constructor(parentModule) {
      this.parentModule = parentModule;

      const self = this;
      this.bindThisConext(['_initialize'],
          self, '');
  }

  bindThisConext(methods, context, suffix = 'Scoped') {
      const self = context;

      if (methods && $.isArray(methods) && methods.length > 0) {
          $(methods).each((index, method) => {
              if (self[method]) {
                  self[method + suffix] = self[method].bind(context);
              } else {
                  console.log(`Method: ${method} Not found in current context.`);
              }
          });
      }
  }

  _defineVars() {
      const _view = this.parentModule.view;
      this.$moduleContext = $(_view.settings.target);
      const elementsID = {
          'main-container': 'ah-cq-container',
          validateCq: 'validate-cq',
          'gwim-cq-form':'gwim-cq',
          'consumer-cq-form':'consumer-cq',
          'challenge-question': 'spa-challenge-question',
          'first-cq-content':'first-cq-content',
          'second-cq-content':'second-cq-content',
          'first-challenge-question':'spa-challenge-question1',
          'second-challenge-question':'spa-challenge-question2',
          spaChallengeAns: 'spa-challenge-ans',
          'Oid-val': 'Oid-val',
          'cq-main-content': 'cq-main-content',
          'generic-error-wrapper': 'generic-error-wrapper',
          'cq-error-content': 'cq-error-content',
          errorTarget: 'cq-error-target',
          infoTarget: 'cq-info-target',
          extraSecurity: 'extraSecurity',
          cancelBtn: 'cq-cancel',
      };

      const elementsClass = {};


      this.elementsSelectors = {};

      $.each(elementsID, (i, val) => {
          this.elementsSelectors[i] = `#${val}`;
      });
      $.each(elementsClass, (i, val) => {
          this.elementsSelectors[i] = `.${val}`;
      });



      return this;
  }
  _errorInline(title, content) {
      if (!content) {
          content = ' ';
      }
      const spartaMessageUtility = new this.parentModule.Message();
      this.$moduleContext.find(this.elementsSelectors.errorTarget).empty();
      spartaMessageUtility.showErrorMessage(this.elementsSelectors.errorTarget, title, content, { insert: 'replace' });
      if (content === ' ') {
          this.$moduleContext.find('#cq-error-target .spartaMessage-icon').removeAttr('style');
          this.$moduleContext.find('#cq-error-target .spartaMessage-text').addClass('spartaMessage-no-text').removeClass('spartaMessage-text');
      }
  }

  _infoInline() {
      const spartaMessageUtility = new this.parentModule.Message();
      this.$moduleContext.find(this.elementsSelectors.errorTarget).empty();
      spartaMessageUtility.showInfoMessage(this.elementsSelectors.infoTarget, this.parentModule.errorMessage.data.error.auth.cqInfo.title, this.parentModule.errorMessage.data.error.auth.cqInfo.message, { insert: 'replace' });
      this.$moduleContext.find('#cq-info-target .spartaMessage-icon').removeAttr('style');
  }

  _getDefaultRequest(widgetType){
     let requestPayload = {};
    if(widgetType === 'OCA-GWIM'){
        requestPayload = {
            "answers": [
                {
                    "question": "TO_BE_FILLED",
                    "questionId": "TO_BE_FILLED",
                    "answer": "TO_BE_FILLED"
                }
            ],
            "filterRules": [
                {
                    "value": "TO_BE_FILLED",
                    "name": "CLIENT"
                },
                {
                    "value": "TO_BE_FILLED",
                    "name": "SOURCE"
                },
                {
                    "value": "TO_BE_FILLED",
                    "name": "FLOW"
                }
            ]
        }
    }else{
        requestPayload = {
                         onlineId: "TO_BE_FILLED",
                         answer:"TO_BE_FILLED",
                         question: "TO_BE_FILLED",
                         questionId: "TO_BE_FILLED",
                         challengeType: 'CQ'
                        }
    }
    return requestPayload;
  }


  _bindEventHandlers() {
      const that = this;
      const main = this.parentModule;


      this.$moduleContext.find(this.elementsSelectors.validateCq)
          .off('click.validateCqData').on('click.validateCqData', () => {
                const widgetInfo = main.Store.getData('widgetConfigData');
              this.$moduleContext.find(this.elementsSelectors.errorTarget).empty();
              let endpoint = main.apiEndPoints.verifyChallengeQuestion;
              if(widgetInfo&&widgetInfo.domain){
                        main.apiEndPoints = ahCawCommons.getEndPoints(main.endpoints, widgetInfo.domain);
                }
              const isValid = spartaValidationFramework.fn.core.validateRequiredFields(this.$moduleContext.find('[required]:visible'));

              if (!isValid) {
                  let errorCode = "CQ_BLANK";
                  that._errorInline(that.parentModule.errorMessage.data.error.auth[errorCode].title,
                      that.parentModule.errorMessage.data.error.auth[errorCode].message);

              } else {
                  let inputJson = {};
                  if(widgetInfo&&widgetInfo.originatingFrom === 'OCA-GWIM'){
                    inputJson = that._getDefaultRequest(widgetInfo.originatingFrom);
                    let encryptKey = main.Store.getData('encryptKey');
                    if(self.currentQuestions && self.currentQuestions.length>0){
                        if(self.currentQuestions.length === 1){
                            $.each(inputJson.answers, (i, dval) => { 
                                $.each(self.currentQuestions,(i,cval)=>{
                                    let k = i+1;
                                    dval.question = cval.text;
                                    dval.questionId = cval.id;
                                    dval.answer = $('#spa-challenge-ans'+k).val();
                                })
                            });
                        }else if(self.currentQuestions.length === 2){ 
                            const answertemp = {
                                "question": "TO_BE_FILLED",
                                "questionId": "TO_BE_FILLED",
                                "answer": "TO_BE_FILLED"
                            }
                            inputJson.answers.push(answertemp);
                            $.each(inputJson.answers, (i, dval) => { 
                                $.each(self.currentQuestions,(j,cval)=>{
                                    let k = i+1;
                                    if(i === j){
                                        dval.question = cval.text;
                                        dval.questionId = cval.id;
                                        dval.answer = $('#spa-challenge-ans'+k).val(); 
                                    }
                                });
                            });
                        }
                    }
                    inputJson.filterRules[0].value = widgetInfo.client;
                    inputJson.filterRules[1].value = widgetInfo.source;
                    inputJson.filterRules[2].value = widgetInfo.usecase;
                    endpoint = main.apiEndPoints.GWIMVerifyCQ;

                                      }else{
                    inputJson = that._getDefaultRequest("CAW");
                    inputJson = {
                        onlineId: this.$moduleContext.find(this.elementsSelectors['Oid-val']).text(),
                        answer: this.$moduleContext.find(this.elementsSelectors.spaChallengeAns).val(),
                        question: main.challengeQuestionData.text,
                        questionId: main.challengeQuestionData.id,
                        challengeType: 'CQ',
                    };

                                      }      

                  const ajaxOptions = {
                      method: 'POST',
                      data: JSON.stringify(inputJson),
                      url: endpoint,
                      crossDomain: true,
                      cache: false,
                      timeout: 60000,
                      processData: false,
                      xhrFields: {
                          withCredentials: true,
                      },
                      headers: {
                          'content-type': 'application/json',
                          clientAIT: '41339',
                          accept: 'application/json',
                          'cache-control': 'no-cache',
                      },
                      dataType: 'json',
                  };
                  const initiateCall = new ahCawTransportUtility();
                  initiateCall._serviceCall(ajaxOptions, (response) => {
                      const data = response.responseData;
                      if(widgetInfo&&widgetInfo.originatingFrom === 'OCA-GWIM'){
                         that._handleGWIMResponse(data);
                      }else{
                        if (data.redirectResult && data.redirectResult.authResult && data.redirectResult.authResult === 'SUCCESS') {
                            data.successCallback = main.callbackTarget;
                            if (that.parentModule.devicePref && that.parentModule.devicePref === 'Y') {

                                main.Events.pub(cawEventsMasterUtility.EVENTS.CQ_SUCCESS, data);
                            } else {
                                main.Events.pub(cawEventsMasterUtility.EVENTS.DP_SUCCESS, data);
                            }
                        } else if (data.redirectResult && data.redirectResult.authResult) {
                            that._errorInline(that.parentModule.errorMessage.data.error.auth[data.redirectResult.authResult].title, that.parentModule.errorMessage.data.error.auth[data.redirectResult.authResult].message ? that.parentModule.errorMessage.data.error.auth[data.redirectResult.authResult].message : null);

                            if (data.redirectResult.authResult === 'CQ_LOCKED') {
                                that.$moduleContext.find(that.elementsSelectors['cq-main-content']).addClass('hidden');
                            }
                        } else if (data.errorInfo && data.errorInfo[0] && data.errorInfo[0].code) {
                            that._errorInline(that.parentModule.errorMessage.data.error.auth[data.errorInfo[0].code].title,
                                that.parentModule.errorMessage.data.error.auth[data.errorInfo[0].code].message);

                            if ( that.parentModule.errorMessage.data.error.auth[data.errorInfo[0].code].type === 'fatal' ){
                                that.$moduleContext.find(that.elementsSelectors['cq-main-content']).addClass('hidden');
                            }
                        } else {
                            that.$moduleContext.find(that.elementsSelectors.spaChallengeAns).val('');
                            that.$moduleContext.find(that.elementsSelectors['challenge-question']).html('');

                            main.view.emit({ context: 'update-challenge-question', data: data.question });
                            this.parentModule.challengeQuestionData.text = data.question.content;
                            this.parentModule.challengeQuestionData.id = data.question.id;
                            that._errorInline(that.parentModule.errorMessage.data.error.auth.invalidAnswer.title, that.parentModule.errorMessage.data.error.auth.invalidAnswer.message);
                        }
                      }

                                        });
              }
          });


      this.$moduleContext.find(this.elementsSelectors.cancelBtn).off('click').on('click', () => {
          main.Events.pub(cawEventsMasterUtility.EVENTS.AH_AUTH_CANCEL, { reason: 'user-cancel' });
      });


      return this;
  }


  _handleGWIMResponse(data){ 
    const that = this;
    const main = this.parentModule;
    if (data.redirectResult && data.redirectResult.authResult && data.redirectResult.authResult === 'SUCCESS') {
        data.successCallback = main.callbackTarget;
        if (that.parentModule.devicePref && that.parentModule.devicePref === 'Y') {

            main.Events.pub(cawEventsMasterUtility.EVENTS.CQ_SUCCESS, data);
        } else {
            main.Events.pub(cawEventsMasterUtility.EVENTS.DP_SUCCESS, data);
        }
    }else if (data.redirectResult && data.redirectResult.authResult && data.redirectResult.authResult === 'LINKAGE-FALIED') {
        data.successCallback = main.callbackTarget;
        main.Events.pub(cawEventsMasterUtility.EVENTS.DP_SUCCESS, data);
    }else{
        that.$moduleContext.find(that.elementsSelectors.spaChallengeAns).val('');
        that.$moduleContext.find(that.elementsSelectors['challenge-question']).html('');
        if(data && data.questions){
            main.view.emit({ context: 'update-challenge-question-Multi', data: data.questions });
        }
        that._errorInline(that.parentModule.errorMessage.data.error.auth.invalidAnswer.title, that.parentModule.errorMessage.data.error.auth.invalidAnswer.message);    
    }
  }

  _redraw(event, data) {
      const main = this.parentModule;
      this.$moduleContext.find(this.elementsSelectors['Oid-val']).text(data);
      this.$moduleContext.find(this.elementsSelectors['main-container']).removeClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['cq-main-content']).removeClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['consumer-cq-form']).removeClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['gwim-cq-form']).remove();
      if (this.parentModule.userPref && this.parentModule.userPref === 'E') {
          this.$moduleContext.find(this.elementsSelectors.extraSecurity).removeClass('hidden');
      } else {
          this.$moduleContext.find(this.elementsSelectors.extraSecurity).addClass('hidden');
      }
  }

  _redrawGWIMV(){
      const main = this.parentModule;
      this.$moduleContext.find(this.elementsSelectors['main-container']).removeClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['cq-main-content']).removeClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['gwim-cq-form']).removeClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['consumer-cq-form']).remove();
      if (this.parentModule.userPref && this.parentModule.userPref === 'E') {
          this.$moduleContext.find(this.elementsSelectors.extraSecurity).removeClass('hidden');
      } else {
          this.$moduleContext.find(this.elementsSelectors.extraSecurity).addClass('hidden');
      }
  }

  _redrawCq(event, data) {
      this._hideErrors();
      if (data && data.text) {
          this.$moduleContext.find(this.elementsSelectors['challenge-question']).html(data.text);
      } else if (data && data.content) {
          this.$moduleContext.find(this.elementsSelectors['challenge-question']).html(data.content);
      } else {

      }
  }

  _redrawMultiCq(event,data){
    self.currentQuestions = data;  
    const that = this;
    if(data.length>1){
        $.each(data, (i, val) => {  
          if(i===0){
             that.$moduleContext.find(that.elementsSelectors['first-challenge-question']).html(val.text);  
          }else{
             that.$moduleContext.find(that.elementsSelectors['second-challenge-question']).html(val.text);
          }
          $('#spa-challenge-ans'+i).val('');
        });
    }else if(data.length === 1){
         $('#spa-challenge-ans1').val('');
         that.$moduleContext.find(that.elementsSelectors['first-challenge-question']).html(data[0].text);
         that.$moduleContext.find(that.elementsSelectors['second-cq-content']).remove();
    }
    $('.oid-header').addClass('hidden');
    $('#record-device-title-container').addClass('hidden');
  }

  _showError(event, data) {
      this.$moduleContext.find('.errors-wrapper, .errors-wrapper .error.verify-info').removeClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['cq-error-content']).text(data);
      this.$moduleContext.find(this.elementsSelectors['cq-main-content']).addClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['main-container']).removeClass('hidden');
  }

  _otherError() {
      const spartaMessageUtility1 = new this.parentModule.Message();
      spartaMessageUtility1.type('error')
          .title('This is my title')
          .message('This is my main message')
          .show('#error-target');
      this.$moduleContext.find(this.elementsSelectors['generic-error-wrapper']).removeClass('hidden');
      this.$moduleContext.find(this.elementsSelectors['main-container']).removeClass('hidden');
  }

  _hideErrors() {
      this.$moduleContext.find(this.elementsSelectors.errorTarget).empty();
  }

  _subscribeEvents() {
      const main = this.parentModule;
      const controller = this.parentModule.controller;


      main.Events.sub(cawEventsMasterUtility.EVENTS.CQ_CLEANUP, () => {
          this.$moduleContext.find(this.elementsSelectors['main-container']).addClass('hidden');
      });

      main.Events.sub(cawEventsMasterUtility.EVENTS.INTERNAL.CLEANUP, () => {
          this.$moduleContext.find(this.elementsSelectors.spaChallengeAns).val('');
          this.$moduleContext.find(this.elementsSelectors['challenge-question']).html('');
      });

      main.Events.sub('Error-Data', (e) => {
          main.errorMessage = e;
      });

      return this;
  }

  _errorRedraw( event, errorCode ) {
      if ( errorCode && this.parentModule.errorMessage.data.error.auth[errorCode] ){
          this._errorInline(this.parentModule.errorMessage.data.error.auth[errorCode].title,
                          this.parentModule.errorMessage.data.error.auth[errorCode].message);

          if ( this.parentModule.errorMessage.data.error.auth[errorCode].type === 'fatal' ){
              this.$moduleContext.find(this.elementsSelectors['cq-main-content']).addClass('hidden');
          }

          this.$moduleContext.find(this.elementsSelectors['main-container']).removeClass('hidden');
      }
  }

  _errorGWIMRedraw(event,errordata){
    if ( errordata.errorCode && this.parentModule.errorMessage.data.error.auth[errordata.errorInfo[0].code] ){
          this._errorInline(this.parentModule.errorMessage.data.error.auth[errordata.errorInfo[0].code].title,
                          this.parentModule.errorMessage.data.error.auth[errordata.errorInfo[0].code].message);

          if ( this.parentModule.errorMessage.data.error.auth[errordata.errorInfo[0].code].type === 'fatal' ){
              this.$moduleContext.find(this.elementsSelectors['cq-main-content']).addClass('hidden');
          }
          this.$moduleContext.find(this.elementsSelectors['main-container']).removeClass('hidden');
      }

      this._redrawMultiCq(errordata)

      }

  _listen() {
      const _view = this.parentModule.view;
      _view.listen({ context: 'PAINT-CQ-MODULE', caller: this, callback: this._redraw });
       _view.listen({ context: 'PAINT-GWIM_CQ-MODULE', caller: this, callback: this._redrawGWIMV });
      _view.listen({ context: 'update-challenge-question', caller: this, callback: this._redrawCq });
      _view.listen({ context: 'update-challenge-question-Multi', caller: this, callback: this._redrawMultiCq })
      _view.listen({ context: 'cq-error-info', caller: this, callback: this._showError });
      _view.listen({ context: 'cq-other-error', caller: this, callback: this._otherError });
      _view.listen({ context: 'show-verify-info', caller: this, callback: this._infoInline });
      _view.listen({ context: 'cq-error-redraw', caller: this, callback: this._errorRedraw });
      _view.listen({ context: 'gwim-cq-error-redraw', caller: this, callback: this._errorGWIMRedraw });
      return this;
  }

  _initialize() {
      this._defineVars()
          ._bindEventHandlers()
          ._subscribeEvents()
          ._listen();
  }
}
